import React, { useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Paper from '@material-ui/core/Paper';
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

const useStyles = makeStyles(styles);

export default function Profile(props) {
  const { user, changeName } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    name: user && user.name,
    maritalStatus: user && user.maritalStatus,
    militaryServiceStatus: user && user.militaryServiceStatus,
    birthDate: user&&new Date(user.birthDate),
    nationalCode: user && user.nationalCode,
    title: user && user.title,
    teamName: user && user.teamName,
    gender: user && user.gender
  });
  const handleDateChange = (date) => {
    setState({ ...state, ['birthDate']: date });
  };
  var Call = () => {
    if (!vmsNationalCode(state.nationalCode)) {
      return swal("کد ملی نادرست است.");
    }
    
    var d = new Date(state.birthDate).getDate();
    var m = new Date(state.birthDate).getMonth() + 1; //Month from 0 to 11
    var y = new Date(state.birthDate).getFullYear();
    var birthDate = '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      name: state.name,
      maritalStatus: state.maritalStatus,
      militaryServiceStatus: state.militaryServiceStatus,
      nationalCode: state.nationalCode,
      gender: state.gender,
      birthDate:birthDate
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
        if (changeName) {
          changeName(state.name)
        }
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  function vmsNationalCode(input) {
    if (!/^\d{10}$/.test(input)
      || input == '0000000000'
      || input == '1111111111'
      || input == '2222222222'
      || input == '3333333333'
      || input == '4444444444'
      || input == '5555555555'
      || input == '6666666666'
      || input == '7777777777'
      || input == '8888888888'
      || input == '9999999999')
      return false;
    var check = parseInt(input[9]);
    var sum = 0;
    var i;
    for (i = 0; i < 9; ++i) {
      sum += parseInt(input[i]) * (10 - i);
    }
    sum %= 11;
    return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
  }


  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });

  };

  const handleDropDownChange = (event) => {
    if (event.target.value == 'true' || event.target.value == 'false')
      setState({ ...state, [event.target.name]: Boolean(event.target.value) });
    else setState({ ...state, [event.target.name]: (event.target.value) });
  };

  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined"  >
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    اطلاعات شخصی
      </Typography>
                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="gender">جنسیت</InputLabel>
                      <Select
                        onChange={handleDropDownChange}
                        defaultValue={user && state.gender}
                        inputProps={{
                          name: 'gender',
                          id: 'gender',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        <MenuItem value={true}>آقا</MenuItem>
                        <MenuItem value={false}>خانم</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.formInput}>
                    <TextField id="standard-basic" name="name" onChange={handleTextBoxChange} defaultValue={user && state.name} label="نام و نام خانوادگی" helperText="مثال: علی علوی" />
                  </div>
                  <div className={classes.formInput}>
                    <TextField id="standard-basic" name="nationalCode" onChange={handleTextBoxChange} defaultValue={user && state.nationalCode} label="کد ملی" helperText="مثال: 0012345678" />
                  </div>


                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="militaryServiceStatus">وضعیت سربازی</InputLabel>
                      <Select
                        defaultValue={user && state.militaryServiceStatus}
                        onChange={handleDropDownChange}
                        inputProps={{
                          name: 'militaryServiceStatus',
                          id: 'militaryServiceStatus',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        <MenuItem value={true}>مشمول</MenuItem>
                        <MenuItem value={false}>غیر مشمول</MenuItem>
                      </Select>
                      <FormHelperText>اگر باید سربازی بروید مشمول هستید.</FormHelperText>
                    </FormControl>
                  </div>
                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <MuiPickersUtilsProvider locale="fa" utils={JalaliUtils}>
                      <KeyboardDatePicker
        okLabel="تأیید"
        cancelLabel="لغو"
        label="تاریخ تولد"
        labelFunc={date => (date ? date.format("jYYYY/jMM/jDD") : "")}
        value={state.birthDate}
        onChange={handleDateChange}
      />
                      </MuiPickersUtilsProvider>
                      <FormHelperText></FormHelperText>
                    </FormControl>
                  </div>
                  <div className={classes.formInput}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="maritalStatus">وضعیت تاهل</InputLabel>
                      <Select
                        onChange={handleDropDownChange}
                        defaultValue={user && state.maritalStatus}
                        inputProps={{
                          name: 'maritalStatus',
                          id: 'maritalStatus',
                        }}
                      >
                        <MenuItem value="">
                          <em>انتخاب کنید</em>
                        </MenuItem>
                        <MenuItem value={true}>متاهل</MenuItem>
                        <MenuItem value={false}>مجرد</MenuItem>
                      </Select>
                      <FormHelperText></FormHelperText>
                    </FormControl>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en + " " + classes.save}>
                  <Button variant="contained" color="primary" disableElevation onClick={Call}>
                    ذخیره سازی
</Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
      </GridContainer>
    </form>
  );
}